/**
 * User Dashboard Configuration
 *
 * Configuration for the user's own portfolio view at /positions.
 * Shows core columns with all features enabled.
 */

import { PortfolioTableConfig } from "./types";

/**
 * User dashboard configuration.
 *
 * To customize columns: Edit the `columns` array below.
 * Column IDs must match keys in columnDefinitions.
 */
export const userDashboardConfig: PortfolioTableConfig = {
  id: "user-dashboard",

  columns: [
    "symbol",
    "targetWeightPct",
    "currentWeightPct",
    "weightDeviation",
    "unrealizedPnlUsd",
    "mktValueUsd",
    "qty",
    "currency",
    "secType",
  ],

  expandedColumns: ["mktValueLocal", "costBasisLocal", "mktPrice", "priceUsd", "sector", "group", "conId"],

  features: {
    search: true,
    filters: true,
    grouping: true,
    export: true,
  },

  dataRequirements: {
    positions: true,
    accountSummary: true,
    batchPrices: true,
    targetPortfolio: false,
    includeSynthetics: false,
    tradableTimes: true,
  },
};
